import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_FULL = "/images/logo-full.png";

export default function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const query = new URLSearchParams(location.search);
  const plan = query.get("plan"); // optional hint
  const cycle = query.get("cycle"); // optional hint

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
        const res = await axios.get(`${API_URL}/api/billing/my-subscription`, config);
        if (!cancelled) setSubscription(res.data);
      } catch {
        if (!cancelled) setSubscription(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <img src={LOGO_FULL} alt="OMNICHEK" className="h-10 mx-auto object-contain" />
          <h1 className="mt-5 text-2xl font-heading font-semibold text-zinc-900">
            Complete your subscription
          </h1>
          <p className="mt-1 text-zinc-500">
            {plan ? `Selected: ${plan}${cycle ? ` (${cycle})` : ""}` : "Choose a plan and pay to continue."}
          </p>
        </div>

        <Card className="border-zinc-200 shadow-sm">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg font-heading text-zinc-900">Subscription</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {loading ? (
              <p className="text-sm text-zinc-500">Loading…</p>
            ) : subscription ? (
              <div className="space-y-2 text-sm text-zinc-700">
                <div className="flex justify-between gap-3">
                  <span className="text-zinc-500">Plan</span>
                  <span className="font-semibold">{subscription.plan_type || subscription.plan?.name || "—"}</span>
                </div>
                <div className="flex justify-between gap-3">
                  <span className="text-zinc-500">Status</span>
                  <span className="font-semibold">{subscription.status || "—"}</span>
                </div>
                {subscription.trial_ends_at ? (
                  <div className="flex justify-between gap-3">
                    <span className="text-zinc-500">Trial ends</span>
                    <span className="font-semibold">
                      {new Date(subscription.trial_ends_at).toLocaleDateString()}
                    </span>
                  </div>
                ) : null}
              </div>
            ) : (
              <p className="text-sm text-zinc-500">
                Please sign in and create an organization to subscribe.
              </p>
            )}

            <div className="pt-2 space-y-2">
              <Button className="w-full" disabled>
                Pay with Razorpay (next)
              </Button>
              <Button variant="outline" className="w-full" onClick={() => navigate("/pricing")}>
                Back to plans
              </Button>
            </div>
          </CardContent>
        </Card>

        <p className="mt-4 text-xs text-zinc-400 text-center">
          Payment integration is the next step; this page is the redirect target for paid plans and trial expiry.
        </p>
      </div>
    </div>
  );
}

